import { LOCALES } from "../locales";

export default {
  [LOCALES.GERMAN]: {
    // general product translation
    January: "Januar",
    February: "Februar",
    March: "März",
    April: "April",
    May: "Mai",
    June: "Juni",
    July: "Juli",
    August: "August",
    September: "September",
    October: "Oktober",
    November: "November",
    December: "Dezember",

    class_policy: "Klassenrichtlinien",
    Faq: "FAQs",
    help: "Hilfe",
    frequently_asked_ques: "Häufig gestellte Fragen",
    customer_support: "Kundendienst",
    user_name: "Benutzername",
    password: "Passwort",
    email_address: "E-Mail-Adresse",
    december: "Dezember",
    // Header Translations
    notification: "Benachrichtigung",
    page_loading_aria: "Seite wird geladen",
    state_loading_aria: "Bundesland wird geladen",
    city_loading_aria: "Stadt wird geladen",
    badge_placeholder: "Platzhalter für Abzeichen",
    badge_overall: "Gesamtabzeichen",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Darstellung Zertifikat",
    certificate_download: "Zertifikat herunterladen",
    prev: "Zurück",
    log_out: "Abmelden",
    // feature names
    feature_progress: "Fortschritt",
    feature_stressAndIntonation_title: "Betonung und Intonation",
    feature_soundOfEnglish_title: "Englische Laute",
    feature_vocabularyCenter_title: "Vokabelcenter",
    feature_grammarCenter_title: "Grammatikcenter",
    feature_culture_centre_title: "Kulturcenter",
    feature_globalCommunityTutorials_title: "Global Community Tutorials",
    feature_industryfeed_title: "Industry Feed",
    feature_newsfeed_title: "News Feed",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_emailTemplates_title: "E-Mail-Vorlagen",
    feature_accentsAndDialects_title: "Akzente und Dialekte",
    feature_writingCenter_title: "Schreibcenter",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "Info",
    legal: "Impressum",
    privacy_policy: "Datenschutzerklärung",
    Terms_conditions: "Allgemeine Geschäftsbedingungen",
    //button translations
    button_continue: "Weiter",
    button_KnowMore: "Mehr erfahren",
    button_BuyNow: "Jetzt kaufen",
    button_Subscribe: "Abonnieren",
    button_GetStarted: "Los geht's",
    button_view: "View",
    button_GoText: "Go",
    button_Resume: "Continue learning",
    button_ViewDetails: "Details anzeigen",
    button_ContinueStudying: "Weiter",
    button_next: "Weiter",
    button_confirm: "Bestätigen",
    // cookie policy
    common_cookiesPolicyText1:
      "Learnship verwendet Cookies, um Ihnen den bestmöglichen Service zu gewährleisten. Wenn Sie auf der Seite bleiben stimmen Sie der zu.",
    common_cookiesPolicyText2: "Cookie-Nutzung",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Herzlich willkommen,",
    login_heloo: "Hallo!",
    login_welcome_text: "Fangen wir an.",
    login_log_in: "Anmelden",
    login_errorIncorrectCreds: "Falscher Benutzername oder falsches Passwort.",
    login_errorContactAmin: "Ihr Konto ist inaktiv. Bitte wenden Sie sich an Ihren Administrator.",
    login_errorSSOuser: "Die Anmeldung muss über das Lernportal Ihres Unternehmens erfolgen.",
    login_forgotPassword: "Passwort vergessen?",
    login_resetPasswordTitle: "Passwort zurücksetzen",
    login_resetSuccess:
      "Wir haben Ihnen eine E-Mail mit einem Link geschickt, über den Sie Ihr Passwort zurücksetzen können.",
    login_resetFailure: "Falsche E-Mail-Adresse",
    // common translations
    message_errorDefault: "Ein Fehler ist aufgetreten.",
    message_successUpdated: "Erfolgreich aktualisiert",
    message_unknownError: "Unknown error",
    message_unAuthorized: "Sie haben keine Berechtigung",
    message_passwordUpdated: "Kennwort erfolgreich aktualisiert",
    message_profileUpdated: "Profil erfolgreich aktualisiert",
    message_welcomeSubmitted: "Erfolgreich übermittelt",
    message_samepasswordError:
      "Bitte geben Sie ein neues Passwort ein. Vergewissern Sie sich, dass es sich nicht um ein bereits genutztes Passwort handelt.",
    SAR: "Region auswählen",
    SAL: "Standort auswählen",
    SAT: "Thema auswählen",
    SAA: "Sprache auswählen",
    link_readmore: "Mehr erfahren",
    //--//
    profile_title: "Profil",
    profile_nameLabel: "Ich heiße: ",
    profile_countryLabel: "Land",
    profile_stateLabel: "Bundesland",
    profile_cityLabel: "Stadt",
    profile_emailLabel: "E-Mail-Adresse",
    profile_prefContactLabel: "Bevorzugte Kontaktmethode",
    profile_prefSkypeLabel: "Private Skype-ID",
    profile_prefMobileLabel: "Handynummer",
    profile_prefLandlineLabel: "Festnetznummer",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Ich habe die Nutzungsbedingungen gelesen und bin mit ihnen einverstanden. ",
    profile_continueAria: "Weiter",
    profile_TermsAria: "Ich akzeptiere die Bedingungen.",
    profile_stateTooltip: "Ihre Zeitzone hilft uns dabei, Ihre Online-Sessions zu planen.",
    profile_cityTooltip:
      "Wenn Sie in keiner der hier gelisteten Städte leben, wählen Sie bitte die nächstgelegene Stadt aus.",
    profile_emailTooltip: "E-Mail-Adresse bestätigen",
    profile_prefTooltip:
      "All Ihre Sessions finden im virtuellen Klassenraum statt, auch wenn Sie im Onboarding-Prozess eine andere Kontaktmethode angegeben haben. Wir fragen Sie ausschließlich für interne Zwecke nach Ihrer bevorzugten Kontaktmethode, damit wir Ihre Lernerfahrung kontinuierlich verbessern können.",
    profile_fnamePlaceholder: "Vorname",
    profile_lnamePlaceholder: "Nachname",
    profile_countryPlaceholder: "Land auswählen",
    profile_prefContactSelect: "Bevorzugte Kontaktmethode auswählen",
    profile_statePlaceholder: "Bundesland auswählen",
    profile_cityPlaceholder: "Stadt auswählen",
    profile_emailInvalidMessage: "Die E-Mail-Adresse ist ungültig.",
    profile_prefContactPlaceholder: "Bevorzugte Kontaktmethode auswählen",
    profile_prefSkypePlaceholder: "Skype (privat)",
    profile_emailVerifiedChip: "Bestätigt",
    profile_emailVerifyChip: "Bestätigen",
    profile_emailpopup_head: "Bestätigungscode eingeben",
    profile_emailpopup_resendText: "Code erneut senden",
    profile_emailpopup_resendMessage: "Code nicht erhalten?",
    profile_invalidNumber: "Ungültige Nummer",
    profile_prefSkypeAria: "Kontaktaufnahme bevorzugt via Skype (privat)",
    profile_prefMobileAria: "Kontaktaufnahme bevorzugt via Handy",
    profile_prefLandlineAria: "Kontaktaufnahme bevorzugt via Festnetz",
    profile_emailpopup_incorrectCode: "Ungültiger Code",
    profile_editLabel: "Profil bearbeiten",
    profile_editAria: "Bearbeiten",
    profile_mainPasswordPlaceholder: "Passwort hier eingeben",
    profile_updateLabel: "Aktualisieren",
    profile_welcomeJumbotron: "Erzählen Sie uns von sich.",
    profile_cancelLabel: "Abbrechen",
    noAccessl1: "Hoppla! Sie sind nicht berechtigt, diese Seite anzusehen.",
    noAccessl2: "Dieser Link führt Sie zurück zur",
    noAccessl2_1: "Startseite.",
    noAccessl3: "Bitte wenden Sie sich an Ihren Administrator, um Hilfe zu erhalten.",
    profile_license_information: "License information",
    profile_license_message: "Ihre Lizenz läuft ab am",
    profile_changepass_changepassHead: "Passwort ändern",
    profile_changepass_currentpassword: "Aktuelles Passwort",
    profile_changepass_currentpasswordPlaceholder: "Aktuelles Passwort eingeben",
    profile_changepass_newpassword: "Neues Passwort",
    profile_changepass_newpasswordPlaceholder: "Neues Passwort eingeben",
    profile_changepass_confirmnewpassword: "Neues Passwort bestätigen",
    profile_passMustInclude: "Ihr Passwort muss die folgenden Anforderungen erfüllen:",
    profile_passdontmatch: "Die Passwörter stimmen nicht überein.",
    profile_incorrectPassword: "Falsches Passwort",
    profile_passwordSubmit_title: "Passwort eingeben",
    profile_changepass_conditionLength: "8 bis 32 Buchstaben",
    profile_changepass_conditionUppercase: "mindestens ein Großbuchstabe",
    profile_changepass_conditionLowercase: "mindestens ein Kleinbuchstabe",
    profile_changepass_conditionSpecialCharacters: "mindestens eine Zahl oder eines der folgenden Symbole: $!#&@?%*_",
    profile_translationLanguage: "Übersetzungssprache",
    profile_translationLanguagePlaceholder: "Sprache auswählen",
    profile_managerEmailPlaceholder: "E-Mail-Adresse des Managers",
    profile_managerEmailpopupPlaceholder: "E-Mail-Adresse des Managers",
    // Learner Home Page translations
    learnerhome_survey_header: "Wir benötigen Ihr Feedback!",
    learnerhome_survey_line1: "Ihr Unternehmen möchte mehr über Ihre Erfahrung mit unserer Dienstleistung erfahren.",
    learnerhome_survey_line2: "Bitte füllen Sie die Umfrage aus bis",
    learnerhome_survey_line3: "Ihr Feedback ist uns sehr wichtig.",
    learnerhome_survey_button1: "An Umfrage teilnehmen",
    learnerhome_survey_button2: "Umfrage überspringen",
    active_course: "Aktiver Kurs",
    admin_header: "Administration",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Klicken Sie auf einen der Kurse, um loszulegen.",
    product_solo_desc:
      "Learnship Solo, unser E-Learning-Produkt, bietet Ihnen alles, was Sie benötigen, um Ihre geschäftssprachlichen Kenntnisse im eigenen Tempo zu üben und zu verbessern.",
    product_conversationPractice_desc:
      "Hier können Sie einzelne Sessions mit Trainern buchen, in denen Fragen gestellt, ein bestimmtes Thema diskutiert oder Rollenspiele durchgeführt werden können. Nützlich für fortgeschrittene Lernende, die ihre Kenntnisse perfektionieren möchten.",
    product_sprint_businessSkills_desc:
      "Dieses Blended-Learning-Programm der nächsten Generation hilft Ihnen, in Rekordzeit spezifische Geschäftskompetenzen zu entwickeln. Derzeit verfügbar: Geschäftspräsentationen, Geschäftsverhandlungen, Geschäftskorrespondenz und Meetings.",
    product_sprint_levelsProgress_desc:
      "Unser Blended Learning-Programm der nächsten Generation hilft Ihnen, Ihre Englischkenntnisse innerhalb eines standardisierten Rahmens schnell zu verbessern.",
    product_sprint_business_german_desc:
      "Unser Blended Learning-Programm der nächsten Generation hilft Ihren Mitarbeitern, ihre Deutschkenntnisse innerhalb eines standardisierten Rahmens schnell zu verbessern.",
    product_sprint_business_french_desc:
      "Unser Blended Learning-Programm der nächsten Generation hilft Ihren Mitarbeitern, ihre Französischkenntnisse innerhalb eines standardisierten Rahmens schnell zu verbessern.",
    product_sprint_business_spanish_desc:
      "Unser Blended Learning-Programm der nächsten Generation hilft Ihren Mitarbeitern, ihre Spanischkenntnisse innerhalb eines standardisierten Rahmens schnell zu verbessern.",
    product_sprint_business_skills_groups_desc:
       "This next-generation blended learning program helps learners develop specific business skills— in groups—in record time.",
    product_evolve_relocationLanguage_desc:
      "Unser Programm für internationale Mitarbeiterentsendungen hilft Ihnen, ein tieferes Verständnis für die Sprache und die sozialen Gepflogenheiten Ihres neuen Aufenthaltslandes zu entwickeln.",
    product_evolve_culturePowerSkills_desc:
      "Hier entwickeln Sie die interkulturellen Kompetenzen, die Sie benötigen, um in einem internationalen Arbeitsumfeld und in globalen virtuellen Teams erfolgreich zu sein.",
    product_evolve_cultureFocus_desc:
      "Länderspezifisches Training und kulturelle Intelligenz für Lernende, die ein besseres Verständnis für eine bestimmte Region und ihre Arbeitskultur entwickeln müssen.",
    product_evolve_cultureChange_desc:
      "Dies ist unser führendes Programm für interkulturelles Geschäftstraining für Expats. Es vermittelt Ihnen ein tiefes Verständnis dafür, was es bedeutet, in einer neuen Kultur zu leben und zu arbeiten.",
    product_elevate_businessSkills_desc:
      "Kurze, standardisierte Trainingsmodule für Lernende, die spezifische Geschäftskompetenzen wie Präsentieren, Verhandeln oder Teamführung verbessern möchten. Wir bieten auch fachspezifische Kurse an, die sich auf branchenspezifische Terminologie konzentrieren.",
    product_elevate_levelsProgress_desc:
      "Dieser trainergeführte Kurs für Geschäftssprache hilft Ihnen, Ihre schriftlichen und mündlichen Kompetenzen innerhalb eines standardisierten Rahmens zu verbessern.",
    product_coach_languageCoach_desc:
      "Kommunizieren Sie in Meetings, in E-Mails, bei Verhandlungen und sogar beim Mittagessen mit Kollegen klar und selbstbewusst. Unser spezifisches Sprachcoaching für Führungskräfte hilft Ihnen, die wichtigsten Geschäftsszenarien zu meistern. Entwickeln Sie Ihre mündlichen, schriftlichen und persönlichen Kommunikationskompetenzen weiter.",
    product_coach_cultureCoach_desc:
      "Ein zielorientiertes Einzelcoaching-Programm für Führungskräfte, die spezifische interkulturelle Kommunikationsprobleme lösen möchten.",
    product_solo_business_english:
      "Ein mehrstufiges Lernprogramm mit interaktiven Online-Übungen, um Ihre Business-Englisch-Kenntnisse in Ihrem eigenen Lerntempo weiterzuentwickeln und anzuwenden.",
    product_solo_business_german:
      "Ein mehrstufiges Lernprogramm mit interaktiven Online-Übungen, um Ihre Business-Deutsch-Kenntnisse in Ihrem eigenen Lerntempo weiterzuentwickeln und anzuwenden.",
    product_solo_business_french:
      "Ein mehrstufiges Lernprogramm mit interaktiven Online-Übungen, um Ihre Business-Französisch-Kenntnisse in Ihrem eigenen Lerntempo weiterzuentwickeln und anzuwenden.",
    product_solo_business_spanish:
      "Ein mehrstufiges Lernprogramm mit interaktiven Online-Übungen, um Ihre Business-Spanisch-Kenntnisse in Ihrem eigenen Lerntempo weiterzuentwickeln und anzuwenden.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Dies ist Ihr Zugang zum Dashboard - einer intuitiven Benutzeroberfläche, die es Administratoren ermöglicht, die Nutzung zu verfolgen, den Fortschritt der Lernenden zu analysieren, Programme zu optimieren und den ROI zu bewerten.",
    product_elevate_desc:
      "Elevate Business English ist unsere digitale, persönliche Trainingslösung für Lernende, die ihre Sprachkompetenzen mit einem eigenen Trainer verbessern wollen.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "Dieses vielfältige Multimediaprogramm kann Ihren Angestellten dabei helfen, ihre Englischkenntnisse anhand eines standardisierten Rahmens in kurzer Zeit zu verbessern.",
    //feature translations
    feature_cultureCentre_desc:
      "Machen Sie sich mit den Kulturen der Regionen vertraut, die für Ihr Geschäfts- und Berufsleben wichtig sind.",
    feature_emailTemplates_desc:
      "Die E-Mail-Vorlagen decken eine Vielzahl von Geschäftsthemen ab. Wählen Sie die gewünschte Vorlage aus und exportieren Sie sie direkt in Ihren E-Mail-Client, wo Sie sie bearbeiten können.",
    feature_newsFeed_desc:
      "Willkommen zu unserer revolutionären Lernerfahrung, die internationale Nachrichten mit einbezieht! Lernen Sie Englisch anhand von Berichten und Fragen, die live von unserem Learnship-System generiert werden.",
    feature_talkWithTeacher_desc:
      "This is for learners who want to apply their new skills in conversation. Users can join a virtual group classroom to practice their chosen language and take part in Q&As with speaking speacialists.",
    feature_industryFeed_desc:
      "Der Industry Feed kombiniert eine Bibliothek von branchenspezifischen Artikeln mit KI-gestützten Sprachübungen. Wählen Sie einen Artikel zusammen mit einem Grammatikpunkt aus, den Sie üben möchten.",
    feature_accentsAndDialects_desc:
      "Entdecken Sie durch unsere Bibliothek mit regionalen Sprechbeispielen die Vielfalt der englischen Sprache weltweit.",
    feature_stressAndIntonation_desc:
      "Sorgen Sie dafür, dass Ihr Englisch natürlicher und verständlicher klingt, indem Sie lernen, beim Sprechen die richtige Betonung, den richtigen Rhythmus und die richtige Intonation zu verwenden.",
    feature_soundOfEnglish_desc:
      "Verbessern Sie Ihre Kommunikationskompetenzen, indem Sie lernen, wie man englische Laute richtig ausspricht.",
    feature_vocabularyCenter_desc:
      "Ohne Grammatik kann nur wenig vermittelt werden. Ohne Wortschatz kann gar nichts vermittelt werden. - David Wilkins",
    feature_grammarCenter_desc:
      "Das Grammatikcenter hilft Ihnen, beim Sprechen und Schreiben korrekte Grammatik anzuwenden. Es umfasst Grammatikthemen wie grundlegende Satzteile, Verben und Verbformen sowie Haupt- und Nebensätze.",
    feature_globalCommunityTutorials_desc:
      "Verbessern Sie Ihre Englischkenntnisse mit dieser wachsenden Sammlung von Lektionen, die von unserer Community entwickelt werden.",
    feature_toeic_desc:
      "Der TOEIC®-Test ist das von internationalen Unternehmen am häufigsten verwendete Instrument zur Bestimmung der Englischkenntnisse von Mitarbeitern. Der TOEIC® verwendet authentisches schriftliches Material und Dialoge, um Ihre Kenntnisse im Bereich Geschäftsenglisch einzuschätzen.",
    feature_toefl_desc:
      "TOEFL®, der „Test of English as a Foreign Language“, wird weltweit von Hochschulen und Universitäten, Regierungsbehörden und Stipendienprogrammen zur Bewertung der Englischkenntnisse verwendet.",
    feature_businessSituations_desc:
      "Das Verzeichnis von Geschäftssituationen macht es Ihnen leicht, bestimmte Übungen zu finden, so dass Sie sich auf die Ausdrücke konzentrieren können, die Sie für die Kommunikation in einer Vielzahl von Geschäftssituationen benötigen.",
    //carousel block translations
    title_feature: "Features",
    we_recommend: "Wir empfehlen außerdem",
    // session report translations
    SessionReport_sessionReport: "Sessionbericht",
    SessionReport_sessionDetails: "Details",
    SessionReport_teacherName: "Name des Trainers",
    SessionReport_sessionReview: "Rückblick",
    SessionReport_sessionFeedback: "Feedback zur Session",
    SessionReport_sessionMaterials_Assignments: "Kursmaterialien und Hausaufgaben",
    SessionReport_instructions: "Anweisungen",
    SessionReport_open: "Öffnen",
    SessionReport_invalidSession_Message: "Für diese Session gibt es leider keinen Bericht.",
    SessionReport_rateSession: "Bewerten Sie Ihre Session",
    SessionReport_handouts: "Handouts",
    SessionReport_coachName: "Wie war Ihre Session mit",
    SessionRating_sessionDate: "Datum der Session",
    SessionRating_sessionTime: "Uhrzeit der Session",
    SessionRating_sessionDuration: "Dauer der Session",
    SessionRating_status: "Status",
    SessionRating_rateYourExperience: "Bewerten Sie Ihre Erfahrung",
    SessionRating_whatWentWrong: "Was ist schiefgelaufen?",
    SessionRating_content: "Lehrinhalt",
    SessionRating_technology: "Technik",
    SessionRating_comment: "Kommentar hinzufügen",
    SessionRating_submit: "Senden",
    SessionRating_remindMeLater: "Später erinnern",
    SessionRating_close: "Schließen",
    SessionRating_completed: "Abgeschlossen",
    sessionRating_sessionDetails_mins: "Minuten",

    // my schedule page translations
    myschedule_availability_abty_given: "Wir arbeiten daran, einen passenden Trainer für Sie zu finden.",
    myschedule_schedule: "Mein Terminplan",
    myschedule_availability_needAvl: "Bitte geben Sie Ihre Verfügbarkeit an, damit wir Ihre Session planen können.",
    myschedule_availability_abty_not_given: "Verfügbarkeit angeben / ändern",
    myschedule_statusCard_completed: "Abgeschlossene Session(s)",
    myschedule_statusCard_remaining: "Verbleibende Session(s)",
    myschedule_statusCard_scheduled: "Zu planende Session(s)",
    myschedule_statusCard_lost: "Verlorene Session(s) (zu spät abgesagt oder verpasst)",
    myschedule_recentUpcoming_courseName: "Kursname",
    myschedule_next_session: "Nächste Session",
    myschedule_session_topic: "Thema der Session",
    myschedule_sessionDetails_communication: "Kommunikationsmedium",
    myschedule_sessionDetails_allSessions: "Alle Sessions",
    myschedule_sessionDetails_upcomingSessions: "Bevorstehende Sessions",
    myschedule_sessionDetails_pastSessions: "Vergangene Sessions",
    myschedule_sessionDetails_teacher_name: "Trainer",
    myschedule_sessionDetails_sessions: "Anzahl",
    myschedule_sessionDetails_date: "Datum",
    myschedule_sessionDetails_time: "Uhrzeit",
    myschedule_sessionDetails_durationText: "Dauer",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Eine Session verschieben",
    myschedule_reschedule_InstrBegin: "So können Sie einen neuen Termin für eine Session mit Ihrem Trainer finden:",
    myschedule_reschedule_instr1a: "Details zur Session prüfen",
    myschedule_reschedule_instr1b: "Uhrzeit und Datum Ihrer Session werden oben angezeigt.",
    myschedule_reschedule_instr2: "Neues Zeitfenster finden",
    myschedule_reschedule_instr3:
      "Sie sehen die Verfügbarkeit Ihres Trainers. Freie Zeitfenster werden in grün angezeigt.",
    myschedule_reschedule_instr4: "Zeitfenster wählen",
    myschedule_reschedule_instr5: "Um Ihren Termin zu verschieben, klicken Sie bitte auf Ihr bevorzugtes Zeitfenster.",
    myschedule_reschedule_next_instr1: "Kein passendes Zeitfenster gefunden",
    myschedule_reschedule_next_instr2:
      "Versuchen Sie bitte, Ihre Sessions nach Möglichkeit nicht abzusagen. Wenn Sie tatsächlich kein passendes Zeitfenster finden können, klicken Sie bitte auf den Button „KEIN PASSENDES ZEITFENSTER“, um Ihre Session abzusagen. In diesem Fall vereinbart entweder Ihr Trainer einen neuen Termin für diese Session oder ein Administrator hilft Ihnen.",
    myschedule_reschedule_next_instr3: "Trainer wechseln",
    myschedule_reschedule_next_instr4a:
      "Wenn Sie Ihren Trainer für eine oder mehrere Ihrer verbleibenden Sessions wechseln möchten, schreiben Sie uns bitte über unser",
    myschedule_reschedule_next_instr4b: "Kontaktformular",
    myschedule_reschedule_next_instr4c:
      "und wählen {productname} und 'Trainer wechseln' aus. Bitte teilen Sie uns mit, aus welchem Grund Sie Ihren Trainer wechseln möchten.",
    myschedule_rechedule_next_info:
      "Für weitere Informationen zum Verschieben und Absagen von Sessions besuchen Sie bitte unser",
    myschedule_rechedule_next_faq: "FAQ-Portal.",
    myschedule_rechedule_next_noShow: "Diese Infoseite nicht mehr anzeigen",
    myschedule_rechedule_next_done: "Fertig",
    myschedule_rechedule_skipButton: "Überspringen",
    myschedule_upcoming_joinNow: "Jetzt teilnehmen",
    myschedule_cancel_question: "Sind Sie sicher, dass Sie diese Session absagen möchten?",
    myschedule_cancel_button: "Session absagen",
    myschedule_cancel_no: "Nein",
    myschedule_invalid_session: "Das ist leider keine gültige Session.",
    myschedule_sessionDuraion_minutes: "Minuten",
    myschedule_homepage_view: "Anzeigen",
    myschedule_finished_status: "Abgeschlossen",
    myschedule_reschedule_button: "Verschieben",
    myschedule_addToCalendar_instr1: "Klicken Sie auf",
    myschedule_addToCalendar_instr2:
      "den Download-Button, um Ihren Learnship Stundenplan herunterzuladen. Sie können den Plan anschließend Ihrem persönlichen Kalender hinzufügen.",
    myschedule_addToCalendar_instr3:
      "Wenn Sie bereits einen Learnship Stundenplan Ihrem persönlichen Kalender hinzugefügt haben, löschen Sie diesen, bevor Sie einen neuen Plan hinzufügen.",
    myschedule_addToCalendar_instr4:
      "Erfahren Sie mehr darüber, wie man den Leanrship Stundenplan dem persönlichen Kalender hinzufügt.",
    myschedule_addToCalendar_instr5: "Hier",
    myschedule_no_teacher_title: "Trainer nicht zugewiesen",
    myschedule_no_teacher_body:
      "Momentan können keine Sessions hinzugefügt werden (Trainer nicht zugewiesen). Bitte wenden Sie sich an coach@globalenglish.com, um mit Ihrem Programm fortzufahren.",
    myschedule_no_sessions: "Keine Sessions gefunden",
    myschedule_no_upcoming_sessions: "Keine geplante Sessions gefunden",
    myschedule_no_past_sessions: "Keine vergangenen Sessions gefunden",
    myschedule_status_lost: "Verloren",
    myschedule_status_finished: "Abgeschlossen",
    myschedule_status_completed: "Abgeschlossen",
    myschedule_status_cancelled: "Abgesagt",
    myschedule_status_inprogress: "Wird bearbeitet",
    myschedule_status_pending: "ausstehend",
    myschedule_status_active: "aktiv",
    myschedule_status_inplanning: "In Planung",

    // my schedule page translations end
    // Progress page
    progress_title: "Mein Fortschritt",
    progress_activity_report: "Aktivitätsbericht",
    progress_test_results: "Testergebnisse",
    progress_productname_sprint_skills: "Sprint Business Skills",
    progress_productname_reach_skills: "Reach Skills",
    progress_skill_note:
      "Sie müssen mindestens 70% der Kursarbeit und Sessions absolvieren, um ein Abschlusszertifikat zu erhalten.",
    progress_overall_card_title_prework: "Vorbereitung abgeschlossen",
    progress_overall_card_title_homework: "Hausaufgaben abgeschlossen",
    progress_overall_card_title_session: "Sessions abgeschlossen",
    progress_overall_card_title_certificate: "Zertifikat",
    progress_overall_card_title_skillsCompleted: "Abgeschlossene Kompetenzen",
    progress_overall_card_title_badgesEarned: "Verdiente Abzeichen",
    progress_overall_card_title_missionsPassed: "Abgeschlossene Missionen",
    progress_overall_card_title_timeInReach: "Zeit in Reach (HH:MM)",
    progress_noSubskill: "Keine Teilkompetenz verfügbar",
    progress_tab_nodata: "Keine Daten verfügbar",
    progress_percentCompleted: "Prozent abgeschlossen",
    progress_subskill_preworkTitle: "Vorbereitung",
    progress_subskill_homeworkTitle: "Hausaufgaben",
    progress_subskill_sessionTitle: "Session",
    progress_subskill_sessionStatusCompleted: "Abgeschlossen",
    progress_subskill_sessionStatusNotCompleted: "Nicht abgeschlossen",
    progress_subskill_sessionStatusNoSessions: "Keine Sessions",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Gesamtzeit",
    progress_activity_tooltip_activitiesCompleted: "Abgeschlossene Übungen",
    progress_activity_tooltip_reachMissionsCompleted: "Abgeschlossene Missionen in Reach",
    progress_activity_tooltip_timeinhhmm: "Zeit in HH:MM",
    progress_activity_tabDaily: "Täglich",
    progress_activity_tabWeekly: "Wöchentlich",
    progress_activity_tabMonthly: "Monatlich",
    progress_activity_tabQuarterly: "Vierteljährlich",
    progress_activity_tabQuarter: "Quartal",
    progress_activity_tabYearly: "Jährlich",
    progress_acitivity_Minutes: "Minuten",
    progress_acitivity_legend_selfpaced: "Im Selbststudium verbrachte Zeit",
    progress_acitivity_legend_trainerLed: "Mit dem Trainer verbrachte Zeit",
    progress_acitivity_legend_recommended: "Empfohlen",
    progress_testresults_table_testname: "Name des Tests",
    progress_testresults_table_scores: "Ergebnisse",
    progress_testresults_table_date: "Datum",
    progress_testresults_info: "Ihre Testergebnisse sind in 24 Stunden verfügbar.",
    progress_inprogress: "Wird bearbeitets",
    progress_totalscore: "Gesamtergebnis",
    progress_placedText: "Eingestuft",
    progress_button_viewscore: "View detailed report",
    progress_certificate_download_success: "Downloaded successfully",
    progress_partText: "Teil",
    progress_emptyPartText: "Other",
    progress_overall_card_title_badge: "Badge",
    progress_badge_dialog_box_title:
      "Um ein Abschlusszertifikat zu bekommen, müssen Sie 70 % der digitalen Übungen abgeschlossen haben.",
    progress_badge_dialog_box_golden: "Bei einer Erfolgsquote von 80 % erhalten Sie ein Goldabzeichen.",
    progress_badge_dialog_box_silver: "Bei einer Erfolgsquote von 70 bis 79 % erhalten Sie ein Silberabzeichen.",
    progress_badge_dialog_box_bronze: "Bei einer Erfolgsquote von 50 bis 69 % erhalten Sie ein Bronzeabzeichen.",
    progerss_badge_dailog_box_digitalActivities:
      "Die Erfolgsquote wird auf der Grundlage Ihrer Leistung und Ihrer Teilnahme bei den digitalen Online-Aktivitäten berechnet",
    progress_badge_dailog_box_liveSessions:
      "Die Erfolgsquote wird auf der Grundlage Ihrer Leistung und Ihrer Teilnahme bei den digitalen Online-Aktivitäten und bei den Live-Sessions berechnet",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",

    //EO Progress page
    //email templates
    languageSelect: "Select a language",
    wcGroup1: "Entschuldigungen",
    wcGroup2: "Beschwerden",
    wcGroup3: "Komplimente",
    wcGroup4: "Beglückwünschungen",
    wcGroup5: "Dokumente",
    wcGroup6: "Einladungen",
    wcGroup7: "Stellenbewerbungen",
    wcGroup8: "Marketing und Verkauf",
    wcGroup9: "Meetings",
    wcGroup10: "Mitteilungen",
    wcGroup11: "Bestellungen",
    wcGroup12: "Preisinformationen",
    wcGroup13: "Bitten, Anfragen",
    wcGroup14: "Danksagungen",
    wcTitle11: "Entschuldigung wegen einer Projektverzögerung",
    wcTitle12: "Entschuldigung wegen eines Buchungsfehlers",
    wcTitle13: "Entschuldigung wegen einer verspäteten Sendung",
    wcTitle14: "Entschuldigung wegen der Zustellung beschädigter Waren",
    wcTitle15: "Entschuldigung wegen eines versäumten Meetings",
    wcTitle21: "Allgemeine Beschwerde",
    wcTitle22: "Beschwerde wegen eines Problems mit einem Produkt",
    wcTitle23: "Beschwerde wegen zu hoher Belastung eines Kontos",
    wcTitle31: "Kompliment an einen Kollegen für ein Projekt",
    wcTitle32: "Kompliment zum Kundenservice",
    wcTitle33: "Kompliment zu einem Produkt",
    wcTitle41: "Glückwünsche zu einer Beförderung (förmlich)",
    wcTitle42: "Glückwünsche zu einer Beförderung (informell)",
    wcTitle43: "Glückwünsche zu einem persönlichen Anlass",
    wcTitle51: "Angefordertes Dokument",
    wcTitle52: "Auftragsformular oder Bestellung",
    wcTitle53: "Rechnung",
    wcTitle61: "Einladung zu einem gesellschaftlichen Anlass",
    wcTitle62: "Einladung zu einer geschäftlichen Veranstaltung",
    wcTitle63: "Eine Einladung annehmen",
    wcTitle64: "Eine Einladung ablehnen",
    wcTitle65: "Eine geschäftliche Veranstaltung absagen",
    wcTitle71: "Bestätigung des Erhalts einer Bewerbung",
    wcTitle81: "Ankündigung eines neuen Produkts",
    wcTitle82: "Bekanntgabe eines neuen regionalen Kundenbetreuers",
    wcTitle83: "Vorführung eines neuen Produkts",
    wcTitle84: "Änderung der Rechnungsanschrift",
    wcTitle85: "Weiterführender Kontakt nach einem ersten Verkaufsgespräch",
    wcTitle86: "Begrüßung neuer Kunden",
    wcTitle87: "Festtagsgruß an Aktionäre oder Kunden",
    wcTitle91: "Einen Termin für ein Gespräch vorschlagen",
    wcTitle92: "Einen Gesprächstermin bestätigen",
    wcTitle93: "Einen Gesprächstermin verschieben",
    wcTitle94: "Einen Gesprächstermin absagen",
    wcTitle95: "Einen Gesprächsinhalt zusammenfassen",
    wcTitle101: "Vorübergehend gesperrtes Konto",
    wcTitle102: "Bitte um Schließung eines Kontos",
    wcTitle111: "Einen Auftrag bestätigen",
    wcTitle112: "Eine Versandbestätigung zustellen",
    wcTitle113: "Einen Auftrag stornieren",
    wcTitle114: "Einen Auftrag ändern",
    wcTitle115: "Eine Lieferung bestätigen",
    wcTitle121: "Preisinformationen zur Verfügung stellen",
    wcTitle122: "Ein Preisangebot annehmen",
    wcTitle123: "Ein Preisangebot ablehnen",
    wcTitle131: "Bitte um Klarstellung",
    wcTitle132: "Bitte um Produktinformationen",
    wcTitle133: "Bitte um Informationen über einen Service",
    wcTitle141: "Allgemeine Danksagungen",
    Blob:
      "Die Muster-E-Mails decken zahlreiche geschäftliche Themen ab. Wählen Sie eine Muster-E-Mail aus und exportieren Sie sie direkt in Ihren E-Mail-Client, wo Sie sie bearbeiten können.",
    OpenInEmail: "In der E-Mail öffnen",
    Quote1: "Derzeit gibt es weltweit 3,3 Milliarden E-Mail-Konten.",
    Quote1By: "Mashable",
    Quote2: "E-Mails erzielen fast doppelt so hohe Ergebnisse wie Mitteilungen über andere Kanäle.",
    Quote2By: "Direct Marketing Lead",
    Quote3: "Pro Sekunde werden 3,5 Millionen E-Mails versendet.",
    Quote3By: "Marketing Lead",
    SelectACategory: "Kategorie auswählen",
    Title: "E-Mail-Vorlagen",
    WatchTutorial: "Einführungsvideo ansehen",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "Nordamerika",
    Cenam: "Mittelamerika",
    SoAm: "Südamerika",
    EUR: "Europa",
    ASIA: "Asien",
    CenASIA: "Zentralasien",
    SoEASIA: "Südostasien",
    MidEAST: "Naher Osten",
    AFR: "Afrika",
    AUST: "Australien",
    Cana: "Kanada",
    Mexi: "Mexiko",
    Uniteds: "Vereinigte Staaten",
    CostaR: "Costa Rica",
    DomRep: "Dominikanische Republik",
    Guate: "Guatemala",
    Jama: "Jamaika",
    Panam: "Panama",
    TriniTob: "Trinidad und Tobago",
    Arge: "Argentinien",
    Braz: "Brasilien",
    Chil: "Chile",
    Vene: "Venezuela",
    Colomb: "Kolumbien",
    Peru: "Peru",
    Urug: "Uruguay",
    Austria: "Österreich",
    Belg: "Belgien",
    Bulg: "Bulgarien",
    Croatia: "Kroatien",
    Czec: "Tschechische Republik",
    Denm: "Dänemark",
    Finl: "Finnland",
    Fran: "Frankreich",
    Germ: "Deutschland",
    Greec: "Griechenland",
    Hung: "Ungarn",
    Icel: "Island",
    Irel: "Irland",
    Ital: "Italien",
    Lith: "Litauen",
    Luxem: "Luxemburg",
    Neth: "Niederlande",
    Norw: "Norwegen",
    Pola: "Polen",
    Port: "Portugal",
    Roma: "Rumänien",
    Russ: "Russische Föderation",
    Serb: "Serbien",
    Slovakia: "Slowakei",
    Slovania: "Slowenien",
    Spai: "Spanien",
    Swed: "Schweden",
    Swit: "Schweiz",
    Turk: "Türkei",
    Ukra: "Ukraine",
    Unitedk: "Vereinigtes Königreich",
    Chin: "China",
    Hong: "Hongkong",
    Indi: "Indien",
    Japa: "Japan",
    Mongo: "Mongolei",
    Pakis: "Pakistan",
    SoKore: "Südkorea",
    SriLan: "Sri Lanka",
    Taiw: "Taiwan",
    Afgh: "Afghanistan",
    Azer: "Aserbaidschan",
    Kaza: "Kasachstan",
    Camb: "Kambodscha",
    Indo: "Indonesien",
    Malay: "Malaysia",
    Phil: "Philippinen",
    Sing: "Singapur",
    Thai: "Thailand",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Irak",
    Isra: "Israel",
    Jor: "Jordanien",
    Kuw: "Kuwait",
    Leb: "Libanon",
    Oma: "Oman",
    Qat: "Katar",
    SauArb: "Saudi-Arabien",
    UAE: "Vereinigte Arabische Emirate",
    Alger: "Algerien",
    Angol: "Angola",
    Egyp: "Ägypten",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenia",
    Malaw: "Malawi",
    Moroc: "Marokko",
    Mozam: "Mosambik",
    Nige: "Nigeria",
    SoAfr: "Südafrika",
    Tanz: "Tansania",
    Ugan: "Uganda",
    Zamb: "Sambia",
    Austra: "Australien",
    NewZea: "Neuseeland",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Machen Sie sich mit den Kulturen der Regionen vertraut, die für Ihr Geschäfts- und Berufsleben wichtig sind.",
    culturenotes_useculturalinfo:
      "Nutzen Sie unsere kulturellen Informationen, um sich auf wichtige Treffen mit Kunden und Mitarbeitern auf der ganzen Welt vorzubereiten.",
    culturenotes_topicfamiliarize:
      "Machen Sie sich mit den Sitten und Gebräuchen anderer Kulturen vertraut. Dazu gehören Geschäftszeiten, Restaurantbesuche, Geschenke, uvm.",
    culturenotes_topiclearnculture:
      "Erfahren Sie mehr über kulturelle Gepflogenheiten und Unterschiede sowie über landesübliche Umgangsformen, um peinliche Fauxpas zu vermeiden.",
    culturenotes_tmaworldtext:
      "Die Länderberichte stammen von unserem Partner TMA World und stehen als PDF-Download zur Verfügung.",
    culturenoteslocation_viewbytopic: "Nach Thema filtern",
    culturenoteslocation_viewbycountry: "Nach Land filtern",
    culurecenter_disclaimer_title: "Haftungsausschluss",
    culturecenter_disclaimer:
      "Bitte betrachten Sie die Informationen, die Sie hier lesen werden, als allgemeinen Leitfaden, der dabei helfen soll, eine fremde Kultur kennenzulernen. Mit diesem Tool erfahren Sie mehr über kulturelle Muster, die Ihnen dabei helfen, kulturelle Unterschiede bei Verhalten, Einstellungen und Reaktionen besser verstehen zu können. Bedenken Sie jedoch, dass die Muster einer Kultur sich von Region zu Region und von Individuum zu Individuum unterscheiden können.",
    culturecenter_intercept_title: "Kulturcenter sind zurück!",
    culturecenter_intercept_text1:
      "Wir freuen uns ankündigen zu dürfen, dass Kulturcenter aufpoliert und wieder verfügbar sind!",
    culturecenter_intercept_text2: "Im Feature Kulturcenter können Sie mehr über die beruflichen Praktiken und Gewohnheiten aus 20 unterschiedlichen Ländern erfahren, wie den USA, Kanada, Mexiko, China, Japan, Indien und vielen mehr …​",
    culturecenter_intercept_direct: "Zu Kulturcenter gehen​",
    dailyNewsFeed_resources: "Ressourcen",
    dailyNewsFeed_daily_News: "Täglicher News Feed",
    dailyNewsFeed_newsfeedoftheday: "News Feed des Tages",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData: "Wir konnten den News Feed leider nicht abrufen. Bitte versuchen Sie es später noch einmal.",
    dailyNewsFeed_viewMoreCategories: "Mehr anzeigen",
    // Email templates end
    //Error Page Translations
    error_not_found: "Hoppla! Seite nicht gefunden.",
    error_contact_csm: "Bitte wenden Sie sich an Ihren Customer Success Manager.",
    error_under: "unter",
    error_maintenance: "Wartung",
    error_under_maintenance: "Unsere Website wird derzeit planmäßig gewartet.",
    error_inconvenience: "Wir entschuldigen uns für die Unannehmlichkeiten.",
    error_tryagain: "Bitte versuchen Sie es später noch einmal.",
    error_tryagainMins: "Bitte versuchen Sie es wieder in",
    error_minutes: "Minute(n)",
    error_hours: "Stunde(n)",
    error_oops: "Hoppla!",
    error_permission_denied: "Sie sind nicht berechtigt, diese Seite anzusehen.",
    error_link_home: "Startseite",
    error_contact_admin: "Bitte wenden Sie sich an Ihren Learnship-Administrator, wenn Sie Hilfe benötigen.",
    error_sorry: "Es tut uns leid",
    error_load: "There was a problem loading this Page.",
    error_clear_cache:
      "-Bitte löschen Sie Ihre Browserdaten, überprüfen Sie die Internetverbindung und versuchen Sie es erneut.",
    error_contact: "Bitte wenden Sie sich an unseren",
    error_contact_cst: "Kundenservice",
    error_forhelp: "wenn Sie Hilfe benötigen.",
    error_having_trouble: "Haben Sie immer noch Probleme?",
    //Accents and Dialects Dropdowns
    AF: "Afrika",
    AS: "Asien",
    AU: "Australien-Ozeanien",
    CA: "Karibik",
    CE: "Mittelamerika",
    EU: "Europa",
    MI: "Nahost",
    NO: "Nordamerika",
    SO: "Südamerika",
    CAMER: "Kamerun",
    EGYPT: "Ägypten",
    ETHIO: "Äthiopien",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "Südafrika",
    TANZA: "Tansania",
    AFGHA: "Afghanistan",
    CHINA: "China",
    INDIA: "Indien",
    INDON: "Indonesien",
    JAPAN: "Japan",
    KAZAK: "Kasachstan",
    LEBAN: "Libanon",
    MONGO: "Mongolei",
    NORTH: "Nordvietnam",
    PAKIS: "Pakistan",
    PHILI: "Philippinen",
    SINGA: "Singapur",
    KOREA: "Korea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwan",
    THAIL: "Thailand",
    TURKM: "Turkmenistan",
    AUSTR: "Australien",
    FIJI_: "Fidschi",
    NEW_Z: "Neuseeland",
    BERMU: "Bermuda",
    CUBA_: "Kuba",
    HAITI: "Haiti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinique (Französisch)",
    TRINI: "Trinidad und Tobago",
    AUSTRI: "Österreich",
    BELAR: "Weißrussland",
    BELGI: "Bulgarien",
    BULGA: "Bulgaria",
    CYPRU: "Zypern",
    CZECH: "Tschechische Republik",
    DENMA: "Dänemark",
    ENGLA: "England",
    FINLA: "Finnland",
    FRANC: "Frankreich",
    GEORG: "Georgien",
    GERMA: "Deutschland",
    GREEC: "Griechenland-Hellas",
    HUNGA: "Ungarn",
    IRELA: "Irland",
    ITALY: "Italien",
    MACED: "Nordmazedonien",
    NETHE: "Niederlande",
    NORTHI: "Nordirland",
    POLAN: "Polen",
    ROMAN: "Rumänien",
    RUSSI: "Russische Föderation",
    SCOTL: "Schottland",
    SPAIN: "Spanien",
    SWEDE: "Schweden",
    SWITZ: "Schweiz",
    TURKE: "Türkei",
    UKRAI: "Ukraine",
    WALES: "Wales",
    IRAN_: "Iran",
    IRAQ_: "Irak",
    ISRAE: "Israel",
    KUWAI: "Kuwait",
    SAUDI: "Saudi-Arabien",
    SYRIA: "Syrien",
    CANAD: "Kanada",
    MEXIC: "Mexiko",
    ARGEN: "Argentinien",
    BRAZI: "Brasilien",
    CHILE: "Chile",
    COLOM: "Kolumbien",
    PARAG: "Paraguay",
    PERU_: "Peru",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow Passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Akzente und Dialekte",
    US: "Vereinigte Staaten von Amerika",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "Kalifornien",
    FLORI: "Florida",
    GEORG_US: "Georgia",
    HAWAI: "Hawaii",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Louisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "New Jersey",
    NEW_Y: "New York",
    NCARO: "North Carolina",
    NDAKO: "North Dakota",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pennsylvania",
    SOUTH_US: "South Carolina",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virginia",
    WEST_: "West Virginia",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "Ihr Unternehmen hat einen monatlichen Bericht über Ihren Fortschritt bei Learnship angefordert. Bitte geben Sie unten die E-Mail-Adresse Ihres Managers ein.",

    // survey and notification
    notification_description_plural:
      "{days} verbleibende Tage zum Ausfüllen der Umfrage. Sie müssen sie bis {date} abschließen.",
    notification_description_singular:
      "Sie haben noch 1 Tag, um die Umfrage auszufüllen. Sie müssen sie bis {date} abschließen",
    notification_maintenance_message: "Halo wird am {date} um {time} planmäßig gewartet.",
    //renewal
    renewal_welcome: "Wir freuen uns, Sie wieder bei Learnship begrüßen zu dürfen!",
    renewal_text:
      "Ihre Learnship-Lizenz läuft am {date}, {month} {year} ab. Verlängern Sie noch heute Ihre Lizenz, wenn Sie Ihre Geschäftsenglisch-Kenntnisse weiter ausbauen möchten. Ihr Lernplan und Ihre gesamten Aktivitäten werden gespeichert und Sie fahren auf Ihrer aktuellen Stufe mit dem Lernmaterial fort.",
    renewal_later: "Zu einem späteren Zeitpunkt erinnern",
    renewal_affirmative: "ich möchte meine Lizenz verlängern.",
    renewal_negative: "ich möchte meine Lizenz nicht verlängern.",
    renewal_yes: "JA",
    renewal_no: "NEIN",
    courselevel: "Kursniveau",
    currentunit: "Aktuelle Lektion",
    upcomingsession: "Bevorstehende Sessions",
    viewschedule: "View Schedule",
    currentskills: "Kompetenzen",
    currentsubskills: "Teil-Kompetenzen",

    // TWT translations
    twt_talk_with_teacher_title: "Mit der Lehrkraft sprechen",
    twt_sub_heading:
      "Trainieren Sie Ihre mündliche Ausdrucksfähigkeit mit Lehrern und anderen Lernenden in unserem Online-Klassenzimmer!",
    twt_select_sessions: "Währen Sie Ihre Sessions:",
    twt_view_schedule_title: "Zeitplan anzeigen und zum Kalender hinzufügen",
    twt_next_week: "Weiter",
    twt_previous_week: "Vorherige Woche",
    twt_add_to_calendar: "Zum Kalender hinzufügen",
    twt_view_more: "Mehr anzeigen",
    twt_topic: "Thema",
    twt_class_policy_title: "Richtlinien für 'Mit der Lehrkraft sprechen'",
    twt_class_policy_subHeading:
      "Die folgenden Richtlinien sind wichtig, um sicherzustellen, dass Ihre Erfahrungen mit TWT (Talk with the Teacher) lehrreich und unterhaltsam ist. Bitte lies sie diese sorgfältig durch.",
    twt_class_policy_list01:
      "Sie können pro Woche eine online Klasse besuchen. Unsere Online-Klassen haben ein Limit von acht Teilnehmer. Best Practice: TWT-Klassenräume sind immer nur in den ersten 10 Minuten zugänglich. Zum Beispiel ist eine Klasse, die um 9:00 Uhr beginnt, bis 9:10 Uhr zugänglich. Nach den ersten 10 Minuten können Sie der Sitzung nicht beitreten. Begrenzter oder unbegrenzter Zugriff ist abhängig von Ihrer Lizenz",
    twt_class_policy_list02_sub1:
      "Wenn Sie den Klassenraum betreten, schreiben Sie Ihren Namen, Ihren Wohnort, Land und Ihre derzeitige Lernstufe in das Chat-Feld.",
    twt_class_policy_list02_sub2: `Beispiel: 'Mein Name ist Leo, und ich komme aus Sao Paulo, Brasilien. Ich bin in Stufe 6.`,
    twt_class_policy_list02_sub3: "Der Lehrer aktiviert dann Ihr Mikrofon und das Mikrofonsymbol wird angezeigt.",
    twt_class_policy_list03:
      "Wenn Sie ein technisches Problem haben, wenden Sie sich an unsere Kundensupport. Klicken Sie oben auf der Seite auf Hilfe um das Problem schriftlich zu melden, oder sprechen Sie mit einem Kundenbetreuer in dem Sie die Chat Schaltfläche rechts unten auf einer beliebigen Seite von Learnship anklicken. Bitte fragen Sie den Lehrer nicht nach technischer Hilfe.",
    twt_class_policy_list04:
      "Es gibt vier TWT Session Stufen: Anfänger, Mittelstufe, Fortgeschrittene und Alle Stufen. Wählen Sie die Session, die Ihrer aktuellen Stufe und Englischkenntnissen entspricht. Zum Beispiel, wenn Sie in den Stufen 0-3 sind, nehmen Sie an einer Anfänger-Klasse teil. Jeder Teilnehmer (ungeachtet der Stufe) kann an den All-Level-Klassen teilnehmen. Wenn Sie einer TWT-Klasse beitreten, die für Ihre Englischkenntnisse nicht geeignet ist, informiert Sie Ihr Lehrer darüber. Sie haben zwei Möglichkeiten: Sie können dem Lehrer sagen, dass Sie bleiben und nur zuhören möchten, d. H. Sie können nicht aktiv teilnehmen (sprechen); oder Sie können eine andere Klasse zu einer anderen Zeit beitreten.",
    twt_class_policy_list05:
      "Wenn Sie an einer online Klasse teilnehmen möchten, ohne zu sprechen, können Sie dies jeweils für eine Stunde pro Woche tun. Danach müssen Sie teilnehmen, indem Sie sich während der Klasse aktiv beteiligen und sprechen. Einer Klasse beizutreten und nur zuhören ist für maximal 4 Sessions pro Jahr möglich. Falls Sie sich danach nicht aktiv am Gespräch beteiligen endet Ihre Session.",
    twt_class_policy_point6:
      "Wir tolerieren keine obszöne oder beleidigende Sprache in Englisch oder in irgendeiner anderen Sprache. Wenn Sie gegen diese Richtlinie verstoßen, werden wir Sie sofort aus der Klasse entfernt, Ihr Manager wird über Ihr beleidigendes Verhalten informiert und wir können Ihr Konto kündigen.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "Sie sind dieser Sitzung bereits von einem anderen Gerät aus beigetreten. Bitte loggen Sie sich aus, bevor Sie vom aktuellen Gerät aus teilnehmen.",
    twt_max_capacity_error_message:
      "Leider können Sie dieser Sitzung nicht beitreten, da die maximale Anzahl Teilnehmer erreicht wurde. Bitte treten Sie einer anderen Sitzung bei.",
    twt_notification_message: "Eine Gesprächssession startet jetzt. Möchten Sie beitreten?",
    twt_limit_message: "Sie haben in dieser Woche bereits an einer Unterrichtsstunde teilgenommen.",
    twt_session_unavailable: "Keine Sitzungen verfügbar",
    twt_select_language: "Sprache auswählen",
    //Vocabulary center translations
    vocab_center_product_headline: "Vocabulary center",
    vocab_center_search_word: "Search and add word",
    vocab_center_add_wordlist: "Add Word List",
    vocab_center_edit_wordlist: "Edit Word List",
    vocab_center_delete_wordlist: "Delete Word List",
    vocab_center_options_text: "Options",
    vocab_center_add_word: "Add Word",
    vocab_center_add_text: "Add",
    vocab_center_delete_wordlist_warning_message: "All the words under the list will be deleted. Click Yes to delete.",
    vocab_center_yes_text: "Yes",
    vocab_center_new_wordlist: "New Word List",
    vocab_center_created_wordlist_success_message: "You have successfully created your new word list",
    vocab_center_updated_wordlist_success_message: "You have successfully updated your word list",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "New Word",
    vocab_center_enter_word_text: "Enter a word",
    vocab_center_word_exists_in_wordlist_warning_message: "This word already exists in this Word List",
    vocab_center_save_text: "Save",
    vocab_center_new_word_message: "This word does not exist. Do you want to create your own definition for the word ?",
    vocab_center_pos_label: "Part of speech",
    vocab_center_select_wordlist_text: "Select a word list",
    vocab_center_word_label: "Word",
    vocab_center_update_wordlist: "Update word list",
    vocab_center_definition_label: "Definition",
    vocab_center_translation_label: "Translation",
    vocab_center_sentence_label: "Sentence",
    vocab_center_note_label: "Note",
    vocab_center_cancel_text: "Cancel",
    vocab_center_delete_word_text: "Delete Word",
    vocab_center_delete_word_warning_message: "Are you sure you want to delete this word from the Word List ?",
    vocab_center_note_updated_message: "Your notes updated successfully!!",
    vocab_center_close_text: "Close",
    vocab_center_no_definition_text: "No definition available",
    vocab_center_no_translation_text: "No translation available",
    vocab_center_no_sentence_text: "No sentence available",
    vocab_center_no_note_text: "No notes added",
    vocab_center_word_save_message: "You have successfully saved the word in your word List",
    vocab_center_word_exists_error_message: "Selected word already exists in the same wordlist",
    vocab_center_submit_text: "Submit",
    vocab_center_delete_text: "Delete",
    vocab_center_edit_text: "Edit",
    vocab_center_no_word_message: "Oops! There are no words in your wordlist. Add new words!",
    vocab_center_no_wordlist_message: "Oops! There are no wordslist in {wordListName}. Add new wordslist!",
    vocab_center_enter_wordlist_text: "Enter a word list",
    vocab_center_feature_text:
      "Without grammar, Very little can be conveyed. Without vocabulary, nothing can be conveyed. - David Wilkins",

    // Stress and inotation translations
    stress_intonation_product_headline: "StressAndIntonation",
    stress_intonation_product_description:
      "Make your English more natural and easier to understand by learning how to use correct stress, rhythm, and intonation when you speak.",

    // Sounds of English translations
    soe_product_headline: "Sounds of English",
    soe_product_description: "Improve your communication skills by learning how to pronounce English sounds correctly.",
    soe_product_vowels: "Vowels",
    soe_product_consonants: "Consonants",
    soe_product_language_selection:
      "Select your language in the drop-down list to find the sounds that may be difficult for speakers of your language. Then select My Sounds to find the sounds that you had trouble with in the Pronunciation Practice and Communication Practice activities.",

    // Writing center
    wc_feature_headline: "Schreibcenter",
    wc_feature_description: "Level up your professional writing ability via our targeted resources.",
    wc_feature_guideGroup1: "Häufige Probleme beim Schreiben",
    wc_feature_guideGroup2: "Allgemeine Geschäftskommunikation",
    wc_feature_guideGroup3: "Geschäftsunterlagen",
    wc_feature_guideTitle11: "Ursachen für unklares Schreiben",
    wc_feature_guideTitle12: "Grundsätzliche Fehler beim Schreiben",
    wc_feature_guideTitle13: "Probleme mit Verben",
    wc_feature_guideTitle21: "Direktheit in der geschäftlichen Kommunikation",
    wc_feature_guideTitle22: "Die Sprache des Verkaufs und Marketings",
    wc_feature_guideTitle23: "Redewendungen aus dem Geschäftsalltag",
    wc_feature_guideTitle31: "Wirkungsvolle E-Mails",
    wc_feature_guideTitle32: "Präsentationen: Allgemeine Tipps",
    wc_feature_guideTitle33: "Präsentationen: Wirkungsvolle Einstiege",

    // sso leaner intercept
    learners_intercept_title: "IMPORTANT NOTICE",
    learners_intercept_text1: "The way you log on to Learnship is changing! Citi has partnered with Learnship to enable Single Sign On access for all global learners. As of 9:00am CEST on November 18, 2022, you will be required to go to ",
    learners_intercept_text2: "It is important to note that you will no longer be able to log-on via ",
    learners_intercept_text3: "Please take note of this change and bookmark the new page. ",
    learners_intercept_text4: "For support, please reach out to your local HR contact or ",
  },
};
